//#region ng
import {
  Component,
  EventEmitter,
  Inject,
  computed,
  effect,
  inject,
  signal,
} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
  ValidationErrors
} from '@angular/forms';
//#endregion

//#region mat
import {
  MatDialogRef,
  MAT_DIALOG_DATA
} from '@angular/material/dialog';
//#endregion

//#region models
import { FOCUS_TIMEOUT } from '../../_shared/_core/_misc/_models/consts';
import { IFormaPgto } from '../../_shared/_mercadeiro/_misc/_models/_interfaces/_cols';
import { CorFormValidation } from '../../_shared/_core/_ng/_models/_classes';
import { IDistribuidoraFormaFormParams } from 'src/app/models/interfaces/params';
//#endregion

//#region custom validators
class CustomValidator {
  static urlImg() {
    return (control: FormControl): ValidationErrors => {
      const URL: string = (control.value || '');
      // console.log(URL);
      if (!!URL) {
        return !!isUrl(URL) ? null : { url: true };
        // return isCreditCard(URL) ? null : { card: true };
      } else {
        return null;
      } // else
    }
  }
}
//#endregion

//#region libs
import { isUrl } from '../../_shared/_libs/_www/_validation';
//#endregion

//#region services
import { FormasPgtoService } from '../../_shared/_mercadeiro/_ng/_services';
//#endregion

@Component({
  selector: 'distribuidora-forma-pgto-form-modal',
  templateUrl: './distribuidora-forma-pgto-form.modal.html',
  styleUrls: ['./distribuidora-forma-pgto-form.modal.scss']
})
export class DistribuidoraFormaPgtoFormModal {
  //#region publics
  // caption = signal<string>('');
  fv = signal<CorFormValidation>(null);
  forma = signal<IFormaPgto>(null);
  caption = computed<string>(
    () => {
      const FORMA: IFormaPgto = this.forma();
      return !FORMA?.id ? 'Nova forma de pagamento' : FORMA?._nome;
    }
  );
  // formaForm = signal<FormGroup>(null);
  formaForm = computed<FormGroup>(
    () => {
      const FORMA: IFormaPgto = this.forma();
      return this.#fb.group({
        // id: [FORMA?.id || guid(16, 16), [Validators.required]],
        tipo: ['dis', [Validators.required,]],
        _nome: [FORMA?._nome || '', [Validators.required]],
        imgLink: [FORMA?.imgLink || '', [Validators.required, CustomValidator.urlImg()]],
      });
    }
  );
  //#endregion

  //#region events
  nomeFocusEvent$ = signal<EventEmitter<boolean>>(new EventEmitter<boolean>());
  //#endregion

  //#region injects
  #dialogRef = inject(MatDialogRef<DistribuidoraFormaPgtoFormModal>);
  #fb = inject(FormBuilder);
  #formasServ = inject(FormasPgtoService);
  //#endregion

  //#region constructor
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IDistribuidoraFormaFormParams,
  ) {
    this.fv.set(new CorFormValidation);
  }
  //#endregion

  //#region lifecycles
  ngOnInit(): void {
    // console.log(this.data);
    this.forma.set(!!this.data?.forma ? this.#formasServ.fix(this.data?.forma) : null);
  }

  ngAfterViewInit() {
    this.#focus();
  }
  //#endregion

  //#region Controls getters
  get nomeRef(): AbstractControl { return this.formaForm()?.get('_nome'); }
  get imgRef(): AbstractControl { return this.formaForm()?.get('imgLink'); }
  //#endregion

  //#region functions
  #focus() {
    setTimeout(
      () => { this.nomeFocusEvent$().emit(true); },
      FOCUS_TIMEOUT
    );
  }
  //#endregion

  //#region methods
  onModalCloseClick(val: any = null) {
    this.#dialogRef.close(val);
  }

  onSubmitClick() {
    this.onModalCloseClick(this.formaForm()?.value);
  }
  //#endregion
}

/*
 data:image/png;base64,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  */
